import { IonText } from '@ionic/react';

export const InnerhivePlusText: React.FC = () => (
    <IonText color="secondary"><b>Innerhive+</b></IonText>
);
